
import React, { useEffect, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";

function ResearchApplicantOverview(props) {

  const { applicant } = props;
  
  if (Object.keys(applicant).length === 0) {
    return;
  }

  const [resume, setResume] = useState(null);

  useEffect(() => {
    // Get applicant's resume from backend
    const body = new FormData();
    body.append("resumeFileName", applicant.resume);
    axios.post("/student/getResume", body, { responseType: "blob" }).then((res) => {
      const blob = new Blob([res.data], { type: "application/pdf" });
      setResume(URL.createObjectURL(blob));
    });
  }, [applicant]);

  return (
    <div className="ApplicantOverview-container rounded-xl bg-white px-6 py-4 flex flex-col h-full">
      <div className="ApplicantOverview-title text-4xl font-bold mb-4  font-brand-primary flex">
        {/* {student.firstName} {student.lastName} */}
      </div>
      <div className="ApplicantOverview-infoContainer flex flex-col text-lg font-brand-primary">
        <div className="ApplicantOverview-infoHeader flex font-bold">Applicant Personal Statement:</div>
        <div className="ApplicantOverview-info flex mb-4">{applicant.applicationDescription}</div>
      </div>

      <iframe className="ApplicantOverview-resume h-full" src={resume} />
    </div>
  );
}

ResearchApplicantOverview.propTypes = {
  applicant: PropTypes.shape({
    applicationId: PropTypes.number,
    positionId: PropTypes.number,
    studentId: PropTypes.number,
    resume: PropTypes.string,
    applicationDescription: PropTypes.string
})
};

ResearchApplicantOverview.defaultProps = {
  applicant: {},
};

export default ResearchApplicantOverview;
